import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

const PrivacyPolicy = () => {
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.300");

  const sections = [
    {
      title: "개인정보처리방침",
      content: `서비스 플플을 운영하는 (주)루나르트(이하 '회사'라 한다)는 개인정보 보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립, 공개합니다. 회사는 개인정보 보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관계 법령을 준수하고 있습니다.`,
    },
    {
      title: "제1조 (개인정보의 처리목적)",
      content: `회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 홈페이지 회원 가입 및 관리
회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별․인증, 회원자격 유지․관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보처리시 법정대리인의 동의여부 확인, 각종 고지․통지, 고충처리 등을 목적으로 개인정보를 처리합니다.

2. 재화 또는 서비스 제공
물품배송, 서비스 제공, 계약서․청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금결제․정산, 채권추심 등을 목적으로 개인정보를 처리합니다.

3. 고충처리
민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리결과 통보 등의 목적으로 개인정보를 처리합니다.

4. 제휴 및 제안
제휴 및 제안 시 사업자가 작성한 내용을 검토하고, 필요 시 연락을 취할 목적으로 개인정보를 처리합니다.

5. 마케팅 및 광고에의 활용
신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.`,
    },
    {
      title: "제2조 (개인정보의 처리 및 보유기간)",
      content: `① 회사는 법령에 명시되어 있거나 정보주체로부터 개인정보를 수집시에 동의받은 개인정보 보유․이용기간 내에서 개인정보를 처리․보유합니다.
② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

<회원 가입 및 로그인관리>
수집·이용하는 개인정보 항목 : 성명, 생년월일, 휴대전화번호, 아이디, 이메일주소, 성별, 연령, 중복가입확인정보(DI), 법정대리인의 휴대전화번호(법정대리인 동의 필요시)
보유기간
1. 원칙: 회원 탈퇴시까지
2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
- 회원 탈퇴 후 복구 요청 기간 종료 시까지 (회원 탈퇴일로부터 90일)
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)

<재화 또는 서비스 제공>
수집·이용하는 개인정보 항목 : 성명, 휴대폰번호, 이메일주소, 은행계좌정보(은행명, 예금주명, 계좌번호), 서비스 이용기록, IP주소, 거래내역
보유기간
1. 원칙: 서비스 공급완료 및 요금결제·정산 완료시까지
2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
- 계약 또는 청약철회 등에 관한 기록: 5년(전자상거래 등에서의 소비자 보호에 관한 법률)
- 대금결제 및 재화 등의 공급에 관한 기록: 5년(전자상거래 등에서의 소비자 보호에 관한 법률)
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)
- 신용정보의 수집, 처리 및 이용 등에 관한 기록: 3년(신용정보의 이용 및 보호에 관한 법률)
- 표시/광고에 관한 기록: 6개월(전자상거래 등에서의 소비자 보호에 관한 법률)

<고충처리>
수집·이용하는 개인정보 항목 : 성명, 휴대전화번호, 아이디, 이메일, 상담내역(문의 유형 및 내용에 따라 추가로 수집 개인정보가 있을 수 있습니다), 법정대리인의 결제정보(이름, 생년월일)
보유기간
1. 원칙: 회원 탈퇴시까지
2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래 등에서의 소비자 보호에 관한 법률)

<서비스 이용과정에서 자동으로 생성되어 수집되는 항목>
수집·이용하는 개인정보 항목 : IP주소, 쿠키, MAC주소, 서비스 이용기록, 기기정보(고유기기식별값, OS버전, APP 버전, 언어 및 국가 등)
보유기간 통신비밀보호법 시행령 제41조에 따른 통신사실확인자료: 3개월 (통신비밀보호법)

<제휴 및 제안>
수집·이용하는 개인정보 항목 : 회사(기관)명, 성명, 이메일, 휴대전화번호, 상담내역
보유기간
1. 원칙: 제휴 및 제안 검토 완료 후 6개월시까지
2. 다만, 다음의 사유에 해당하는 경우에는 그 해당 기간 종료시까지
- 계약 또는 청약철회 등에 관한 기록: 5년(전자상거래 등에서의 소비자 보호에 관한 법률)

<마케팅 및 광고에의 활용>
수집·이용하는 개인정보 항목 : 서비스 이용기록, 결제기록, 휴대전화 번호, 이메일, 본인확인 정보(이름, 생년월일, 성별, 통신사명, 휴대전화 번호, 동일인식별정보(CI), 중복가입확인정보(DI), 내/외국인 정보), IP 정보, 쿠키 등의 광고식별자
보유기간: 회원 탈퇴시까지 또는 동의철회시까지`,
    },
    {
      title: "제3조(개인정보 제3자 제공)",
      content: `① 회사는 정보주체의 개인정보를 제1조 (개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. 현재 회사는 제3자에게 개인정보를 제공하고 있지 않으며, 만일 제3자 제공이 발생하는 경우 정보주체의 동의를 얻어 최소한의 범위로만 제공할 예정입니다.
② 제1항에도 불구하고, 회사는 재난, 감염병, 급박한 생명·신체의 위험을 초래하는 사건·사고,급박한 재산 손실 등의 긴급상황이 발생하는 경우 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다. 이 경우 회사는 근거 법령에 의거하여 필요한 최소한의 개인정보만을 제공하며, 목적과 다르게 제공하지 않겠습니다.`,
    },
    {
      title: "제4조(개인정보 처리의 위탁)",
      content: `① 회사는 원활한 서비스 운영을 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
수탁업체 동현회계법인
위탁하는 업무내용 수익 정산, 세무 및 회계 관련 업무 대행
개인정보의 보유 및 이용기간 서비스 이용종료 또는 위탁계약 종료시까지

수탁업체 ㈜ 토스페이먼츠
위탁하는 업무내용 신용카드, 계좌이체, 도서상품권, 문화상품권 결제 대행
개인정보의 보유 및 이용기간 서비스 이용종료 또는 위탁계약 종료시까지

② 개인정보처리의 위탁 중 국외법인에서 처리하는 위탁업무는 아래와 같습니다.

수탁업체(정보관리책임자 연락처) Amazon Web Services Inc (aws-korea-privacy@amazon.com)
이전되는 국가 AWS의 리전 (미국)
이전일시 및 방법 서비스이용 시마다 네트워크를 통한 전송
개인정보 항목 서비스를 이용하면서 수집·이용되는 개인정보
이용목적 서비스 제공을 위한 시스템 운영
보유 및 처리기간 위탁 계약 종료 시 또는 본 개인정보 처리방침에 규정된 보관기간에 따름

수탁업체(정보관리책임자 연락처) Bubble
이전되는 국가 미국
이전일시 및 방법 서비스이용 시마다 네트워크를 통한 전송
개인정보 항목 서비스를 이용하면서 수집·이용되는 개인정보
이용목적 서비스 제공을 위한 시스템 운영
보유 및 처리기간 위탁 계약 종료 시 또는 본 개인정보 처리방침에 규정된 보관기간에 따름`,
    },
    {
      title: "제5조(정보주체와 법정대리인의 권리․의무 및 행사방법)",
      content: `① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
1. 개인정보 열람요구
2. 오류 등이 있을 경우 정정 요구
3. 삭제요구
4. 처리정지 요구
② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다.
③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 처리 방법에 관한 고시(제2020-7호) 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
④ 개인정보 열람 및 처리정지 요구는 개인정보 보호법 제 35 조 제 4 항, 제 37 조 제 2 항에 의하여 이용자의 권리가 제한될 수 있습니다.
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
⑦ 회사는 원칙적으로 만 14세 미만 아동의 개인정보를 수집하지 않습니다.`,
    },
    {
      title: "제6조(개인정보의 파기)",
      content: `① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
1. 파기절차
회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
2. 파기방법
회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 복구 및 재생할 수 없도록 로우레밸포멧(Low Level Format) 등의 방법을 이용하여 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.`,
    },
    {
      title: "제7조(개인정보의 안전성 확보조치)",
      content: `회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
1. 관리적 조치 : 내부관리계획 수립․시행, 정기적 직원 교육, 정기적인 접속기록 점검, 수탁사 점검 등
2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치
3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제`,
    },
    {
      title: "제8조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항)",
      content: `① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)' 를 사용합니다.
② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
나. 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 [도구]메뉴에서 [인터넷옵션]->[보안]->[사용자 정의수준]을 선택하여 쿠키에 의한 정보 수집 수준을 정하거나 쿠키 저장을 거부 할 수 있습니다.
다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.`,
    },
    {
      title: "제9조(개인정보 보호책임자 및 담당자)",
      content: `① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자/담당자
성명 : 권재의
직책 : 운영자
이메일 : contact@plpl.kr   
※ 개인정보 보호 담당부서로 연결됩니다.

② 정보주체는 회사의 서비스(또는 사업)를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있으며, 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다. 다만, 부득이한 사유로 처리가 지연될 경우 회사는 그 사유를 정보주체에게 안내할 것입니다.`,
    },
    {
      title: "제10조(개인정보 열람청구)",
      content: `정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.

▶ 개인정보 열람청구 접수․처리 부서
부서명 : 고객센터
담당자 : 박민주
연락처 : <02-2138-2874>`,
    },
    {
      title: "제11조(권익침해 구제방법)",
      content: `정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.

▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)
- 소관업무 : 개인정보 침해사실 신고, 상담 신청
- 홈페이지 : privacy.kisa.or.kr
- 전화 : (국번없이) 118
- 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터

▶ 개인정보 분쟁조정위원회
- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
- 홈페이지 : www.kopico.go.kr
- 전화 : (국번없이) 1833-6972
- 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층

▶ 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr)
▶ 경찰청 사이버안전국 : 182 (http://cyberbureau.police.go.kr)`,
    },
    {
      title: "제12조(개인정보 처리방침의 적용범위)",
      content: `① 이 개인정보 처리방침은 회사가 제공하는 모든 서비스에 적용되지만, 서비스의 특성이 상이한 경우에는 서비스 별로 작성된 개인정보 처리방침이 적용될 수 있습니다.
② 회사 서비스에 링크되어 있는 다른 회사의 웹사이트를 방문하거나, 방문하신 웹사이트에서 개인정보를 수집하는 경우 본 개인정보 처리방침이 적용되지 않습니다.`,
    },
    {
      title: "제13조(Privacy Policies of 3rd Parties We Integrate With)",
      content: `플플 및 회사는 유튜브의 데이터를 제공하기 위해 YouTube API Services 를 이용하고 있으며, 플플의 사용자는 YouTube Terms of Service, Google Privacy Poilcy를 아래 링크에서 확인할 수 있습니다.

Applies to All Customers -
[Google Privacy Policy]

Applies to All Customers -
[YouTube API Terms of Service]

Applies to All Customers -
[Terms of Service]`,
    },
    {
      title: "제14조(개인정보 처리방침 시행 및 변경)",
      content: `① 개인정보는 제3자에게 제공되지 않습니다. 하지만 블링과 연계된 서비스 또는 결제와 같이 제3자의 응대가 필요한 경우, 동의를 통해 개인정보가 전달될 수도 있습니다. 개인정보는 서비스 이용 완료 또는 고객 응대 후 파기됩니다.
② 이 개인정보 처리방침은 2023. 10. 4. 일부터 적용됩니다.`,
    },
  ];

  return (
    <Box bg={bgColor} minH="100vh" py={8}>
      <Container maxW="container.lg">
        <VStack align="start" spacing={8}>
          <Heading as="h1" size="lg" mb={6}>
            개인정보처리방침
          </Heading>

          {sections.map((section, index) => (
            <Box key={index} width="100%">
              <Heading as="h2" size="sm" mb={4}>
                {section.title}
              </Heading>
              <Text
                color={textColor}
                whiteSpace="pre-line"
                mb={8}
                fontSize="sm"
              >
                {section.content}
              </Text>
            </Box>
          ))}
        </VStack>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
